import React from "react";
import InsightCard from "../InsightCard/InsightCard";
import "../../styles/insightCards.css";

/**
 * Card showing key ports as text.
 */
export default function KeyPortsCard({ portsText }) {
  return (
    <InsightCard title="Key Ports">
      <div className="insight-columns">
        <div className="insight-column" style={{ marginRight: 0 }}>
          <div style={{ fontSize: "14px", color: "#424242" }}>{portsText}</div>
        </div>
      </div>
    </InsightCard>
  );
}
